import React from 'react'
import Logo from '../common/Logo'

function LegalLayout({ titre, children, onRetour }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: '0 0 60px' }}>
      <div style={{ background: 'white', borderBottom: '1px solid #e2e8f0', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 16 }}>
        <button onClick={onRetour} style={{ background: 'none', border: 'none', color: '#718096', cursor: 'pointer', fontSize: 14, display: 'flex', alignItems: 'center', gap: 6 }}>← Retour</button>
        <Logo size="sm" withText={true} />
      </div>
      <div style={{ maxWidth: 800, margin: '40px auto', padding: '0 24px' }}>
        <div style={{ background: 'white', borderRadius: 16, padding: '48px 56px', boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
          <h1 style={{ fontSize: 28, fontWeight: 800, color: '#0f172a', marginBottom: 8 }}>{titre}</h1>
          <p style={{ fontSize: 13, color: '#a0aec0', marginBottom: 40, borderBottom: '1px solid #f0f0f0', paddingBottom: 24 }}>
            Derniere mise a jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
          {children}
        </div>
      </div>
    </div>
  )
}

function H2({ children }) {
  return <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1D9E75', marginTop: 36, marginBottom: 12 }}>{children}</h2>
}
function P({ children }) {
  return <p style={{ fontSize: 15, color: '#4a5568', lineHeight: 1.75, marginBottom: 14 }}>{children}</p>
}
function Li({ items }) {
  return (
    <ul style={{ paddingLeft: 20, marginBottom: 14 }}>
      {items.map((item, i) => <li key={i} style={{ fontSize: 15, color: '#4a5568', lineHeight: 1.75, marginBottom: 6 }}>{item}</li>)}
    </ul>
  )
}

export default function RGPD({ onRetour }) {
  return (
    <LegalLayout titre="Politique de Confidentialite — RGPD" onRetour={onRetour}>

      <H2>1. Responsable du traitement</H2>
      <P>Le responsable du traitement des donnees personnelles collectees sur la plateforme Suiveo BTP est la societe <strong>[NOM DE LA SOCIETE]</strong>, [forme juridique], dont le siege social est situe au <strong>[ADRESSE]</strong>. Pour toute question relative au traitement de vos donnees, vous pouvez contacter notre Delegue a la Protection des Donnees (DPO) a l adresse : <strong>dpo@suiveo-btp.fr</strong></P>

      <H2>2. Donnees collectees</H2>
      <P>Dans le cadre de l utilisation de la plateforme Suiveo BTP, nous collectons les categories de donnees suivantes :</P>
      <Li items={[
        "Donnees d identite : nom, prenom",
        "Donnees de contact : adresse email professionnelle",
        "Donnees de connexion : identifiants de session, adresse IP, logs de connexion",
        "Donnees liees aux chantiers : informations projet, taches, avancements, documents, photos",
        "Donnees de facturation : historique d abonnements (pour les architectes)",
      ]} />
      <P>Nous ne collectons aucune donnee de localisation, aucun numero de telephone, et aucune donnee sensible au sens du RGPD.</P>

      <H2>3. Finalites du traitement</H2>
      <P>Vos donnees personnelles sont traitees pour les finalites suivantes :</P>
      <Li items={[
        "Creation et gestion de votre compte utilisateur",
        "Fourniture des services de la plateforme (gestion de chantiers, taches, messagerie)",
        "Gestion de la relation commerciale et de la facturation (abonnements architectes)",
        "Envoi de notifications liees a votre activite sur la plateforme",
        "Amelioration et securisation de la plateforme",
        "Respect des obligations legales",
      ]} />

      <H2>4. Base legale</H2>
      <P>Le traitement de vos donnees est fonde sur :</P>
      <Li items={[
        "L execution du contrat (CGU / CGV) pour la fourniture du service",
        "L interet legitime de Suiveo BTP pour la securisation et l amelioration du service",
        "Le consentement pour l envoi de communications optionnelles",
        "L obligation legale pour la conservation de certaines donnees comptables",
      ]} />

      <H2>5. Duree de conservation</H2>
      <P>Vos donnees sont conservees pendant la duree de votre utilisation du service, augmentee d une periode de :</P>
      <Li items={[
        "3 ans a compter de la derniere activite pour les donnees de compte",
        "10 ans pour les documents comptables",
        "1 an pour les logs de connexion",
      ]} />
      <P>A l expiration de ces delais, vos donnees sont supprimees ou anonymisees de maniere irreversible.</P>

      <H2>6. Vos droits</H2>
      <P>Conformement au RGPD (Reglement UE 2016/679), vous disposez des droits suivants :</P>
      <Li items={[
        "Droit d acces : obtenir une copie de vos donnees personnelles",
        "Droit de rectification : corriger les donnees inexactes",
        "Droit a l effacement : demander la suppression de vos donnees",
        "Droit a la limitation du traitement",
        "Droit a la portabilite : recevoir vos donnees dans un format structure",
        "Droit d opposition : vous opposer au traitement fonde sur l interet legitime",
      ]} />
      <P>Pour exercer ces droits, contactez-nous a l adresse : <strong>dpo@suiveo-btp.fr</strong>. Nous repondons dans un delai de 30 jours. Vous pouvez egalement introduire une reclamation aupres de la CNIL (www.cnil.fr).</P>

      <H2>7. Destinataires des donnees</H2>
      <P>Vos donnees sont traitees par Suiveo BTP et ses sous-traitants techniques :</P>
      <Li items={[
        "Supabase Inc. (hebergement base de donnees et authentification) — serveurs en Union Europeenne",
        "Vercel Inc. (hebergement de la plateforme web) — transferts encadres par les clauses contractuelles types UE",
      ]} />
      <P>Vos donnees ne sont jamais vendues ni cedees a des tiers a des fins commerciales.</P>

      <H2>8. Cookies</H2>
      <P>La plateforme Suiveo BTP utilise uniquement des cookies techniques strictement necessaires au fonctionnement du service (session d authentification). Aucun cookie publicitaire, de tracking ou d analyse comportementale n est utilise.</P>

      <H2>9. Securite</H2>
      <P>Suiveo BTP met en oeuvre des mesures techniques et organisationnelles appropriees pour proteger vos donnees : chiffrement des communications (HTTPS/TLS), acces controles par authentification forte, isolation des donnees par utilisateur via Row Level Security (RLS).</P>

      <H2>10. Contact</H2>
      <P>Pour toute question relative a cette politique ou a l exercice de vos droits, contactez-nous : <strong>dpo@suiveo-btp.fr</strong> — [ADRESSE POSTALE]</P>

    </LegalLayout>
  )
}
